import { InMemoryCache, defaultDataIdFromObject } from '@apollo/client'

// =======================================================
// Apollo Cache
// =======================================================

const apolloCache = new InMemoryCache({
   possibleTypes: {
      ContentElement: [
         'BlockElement',
         'ColumnElement',
         'CustomElement',
         'FileListElement',
         'GridBlockElement',
         'MediaElement',
         'RichTextElement'
      ],
      FileInstance: [
         'FileImageInstance',
         'FileVideoInstance',
         'FileOtherInstance'
      ],
      File: [
         'FileImage',
         'FileVideo',
         'FileOther'
      ],
      Message: [
         'HumanMessage',
         'SystemMessage'
      ],
      NavElement: [
         'NavExternalLinkElement',
         'NavInternalLinkElement'
      ],
      Owner: [
         'Initiative',
         'Organization'
      ],
      RelationshipElement: [
         'RelationshipElementCheckedIn',
         'RelationshipElementFavorited',
         'RelationshipElementRoleParticipant',
         'RelationshipElementSubscribed'
      ],
      RelationshipEntity: [
         'Initiative',
         'Organization'
      ],
      Thread: [
         'FileThread',
         'InitiativeThread',
         'UserThread'
      ]
   },
   dataIdFromObject: (object) => {
      switch (object.__typename) {
         case 'GatherBillingProfileFragment':
            return null
         // Don't cache InitiativeType because its value
         // is contextual to its organization or initiative
         // parent
         case 'InitiativeType':
            return null
         case 'ProductSubscription':
            return 'planId'
         // Fall back to default handling
         default:
            return defaultDataIdFromObject(object)
      }
   }
})

export default apolloCache
